export default "__VITE_ASSET__DbKuOYe9__"